module.exports = require("./ti-ER.d.ts");